/*
 * The Collection Bag — gratis cadeau in de winkelwagen
 * -------------------------------------------------------------
 * Houdt de winkelwagen in sync met de belofte op de site:
 *   - Zit er een Collection Bag in de wagen? Dan wordt er automatisch
 *     één magnetische slab toegevoegd als cadeau.
 *   - Gaat de tas eruit? Dan verdwijnt het cadeau ook.
 *
 * Het cadeau krijgt een verborgen eigenschap (_tcb_gift) zodat een slab
 * die de klant zelf koopt met rust wordt gelaten.
 *
 * De prijs wordt op €0,00 gezet door de automatische korting
 * "Gratis magnetische slab bij pre-order" in de Shopify-admin.
 * Zonder die korting is dit script waardeloos — beide horen bij elkaar.
 *
 * Config komt uit snippets/tcb-free-gift.liquid (window.TCBFreeGift).
 */
(function () {
  var cfg = window.TCBFreeGift;
  if (!cfg || !cfg.bagProductId || !cfg.giftVariantId) return;

  var GIFT_FLAG = '_tcb_gift';
  var syncing = false;

  function routes() {
    return window.routes || {};
  }

  function getCart() {
    return fetch((routes().cart_url || '/cart') + '.js', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
    }).then(function (r) {
      return r.json();
    });
  }

  function isGiftLine(item) {
    return (
      item.variant_id === cfg.giftVariantId &&
      item.properties &&
      item.properties[GIFT_FLAG]
    );
  }

  function addGift() {
    var body = { items: [{ id: cfg.giftVariantId, quantity: 1, properties: {} }] };
    body.items[0].properties[GIFT_FLAG] = 'true';

    return fetch(routes().cart_add_url || '/cart/add', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(body),
    });
  }

  function setGiftQuantity(key, quantity) {
    return fetch(routes().cart_change_url || '/cart/change', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: key, quantity: quantity }),
    });
  }

  function refreshUI() {
    var drawer = document.querySelector('cart-drawer');
    var cartItems = document.querySelector('cart-items');

    // Op de winkelwagenpagina is een verse render het betrouwbaarst.
    if (cartItems && !drawer) {
      window.location.reload();
      return;
    }
    if (!drawer || typeof drawer.getSectionsToRender !== 'function') return;

    var ids = drawer
      .getSectionsToRender()
      .map(function (section) {
        return section.id;
      })
      .join(',');

    fetch((routes().cart_url || '/cart') + '?sections=' + encodeURIComponent(ids), {
      credentials: 'same-origin',
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (sections) {
        if (typeof drawer.renderContents === 'function') {
          drawer.renderContents({ sections: sections });
        }
      })
      .catch(function () {
        /* stil falen: de winkelwagen zelf klopt hoe dan ook */
      });
  }

  function sync() {
    if (syncing) return;
    syncing = true;

    getCart()
      .then(function (cart) {
        var hasBag = false;
        var giftKey = null;
        var giftQty = 0;

        cart.items.forEach(function (item) {
          if (item.product_id === cfg.bagProductId) hasBag = true;
          if (isGiftLine(item)) {
            giftKey = item.key;
            giftQty = item.quantity;
          }
        });

        if (hasBag && giftQty === 0) return addGift();
        if (hasBag && giftQty > 1) return setGiftQuantity(giftKey, 1);
        if (!hasBag && giftKey) return setGiftQuantity(giftKey, 0);
        return null;
      })
      .then(function (changed) {
        syncing = false;
        if (changed) refreshUI();
      })
      .catch(function () {
        syncing = false;
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else {
    sync();
  }

  // Reageer op elke wijziging die het thema zelf doorvoert.
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
      window.setTimeout(sync, 60);
    });
  }
})();
